module.exports = __webpack_public_path__ + "img/chatbubble-ellipses.45bee3f5.svg";